<template>
  <div class="app-footer">
    <el-row type="flex" justify="center" align="middle" class="footer-container">

      <el-col class="footer-about">
        <el-image :src="require('@/assets/QRcode/qrCode.jpg')" style="width: 100px;" alt="二维码" />
      </el-col>

      <el-col class="footer-service">
        <h5>联系方式</h5>
        <div>咨询电话: 0371-8615 3538  /  0371-8661 7973</div>
        <div>公司地址: 河南省郑州市高新区企业创富中心</div>
      </el-col>

      <el-col class="footer-contact">
        <h5>友情链接</h5>
        <div class="friend-link">
          <div v-for="(item, index) in link" :key="index">
            <el-link :href="item.url" target="_blank">{{ item.title }}</el-link>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row type="flex" justify="center" align="middle" class="footer-bottom">
        <el-col style="text-align: center;">
          <el-link href="https://beian.miit.gov.cn/#/Integrated/index" type="info" target="_blank">
            {{ contact.web_site_copyright }} | {{ contact.web_site_icp }}
          </el-link>
        </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  computed: {
    contact() {
      return this.$store.state.getHomeData.contact
    },
    link() {
      return this.$store.state.getHomeData.link
    }
  },
  data() {
    return {
    }
  },
  methods: {

  },
  created() {

  }
}
</script>

<style lang="scss">
.app-footer{
  width: 100%;
  margin: 0 auto;
  background-color: #f1f1f1;
  padding: 8vh 0 0 0;
  .footer-container {
    width: 80%;
    display: flex;
    align-items: flex-start;
    text-align: center;
    margin: 0 auto;
    .el-image {
      width: 160px;
    }
  }
  .footer-service{
    flex: 1;
    line-height: 30px;
    text-align: left;
    border-right: 1px solid #ccc;
    padding-left: 30px;
    h5{
      color: #333;
      margin-bottom: 10px;
    }
    div{
      color: rgba(103,107,123,1);
      font-size: 14px;
    }
  }
  .footer-about{
    flex: 1;
    text-align: center;
    padding-right: 30px;
    border-right: 1px solid #ccc;
  }
  .footer-contact {
    flex: 1;
    padding-left: 30px;
    text-align: left;
    .friend-link {
      display: flex;
      align-items: flex-start;
      flex-direction: row;
      .el-link {
        margin-right: 20px;
      }
    }
  }
  .footer-bottom {
    flex: 1;
    padding-top: 10vh;
    position: relative;
    bottom: 10px;
    font-size: 12px;
  }
}
</style>
